export const TAG_CAP_LENGTH = 25;
